export default __webpack_public_path__ + "images/0aebe422c2535a656af51f3875da17c7.png";